import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/admin/travel-policies` — dal 01-11-2026 le pagine di «Organizzazione» stanno tutte sotto `/organization/`.
 * L'indirizzo vecchio resta come rinvio, coi suoi parametri, per i preferiti e i collegamenti salvati.
 */
export const Route = createFileRoute('/_app/admin/travel-policies')({
  beforeLoad: ({ search }) => { throw redirect({ to: '/organization/travel-policies', search: search as never, replace: true }); },
});
